import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';

@Component({
  name: 'CmgSweepstakeModal',
})

export default class CmgSweepstakeModal extends Vue {

  get visible(): boolean {
    return this.$appStore.state.ui.modals.sweepstakeModal.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.sweepstakeModal.args;
  }

  get title(): string | null {
    return (this.args && this.args.title) || '';
  }

  get body(): string | null {
    return (this.args && this.args.body) || '';
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }
  
  close() {
    this.$services.ui.setModalVisibility('sweepstakeModal', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }
}
